import { picoapp } from 'picoapp';

import hero from './components/hero';
import header from './components/header';
import marquee from './components/marquee';
import testimonials from './components/testimonials';
import instagram from './components/instagram';
import product from './components/product';
import announcement from './components/announcement';
import account from './components/account';
import newsletter from './components/newsletter';
import password from './components/password';
import accordion from './components/accordion';
import blogMenu from './components/blogMenu';
import customBlush from './components/customBlush';
import recentCreations from './components/recentCreations';
import videoEmbed from './components/videoEmbed';

const state = {};

const components = {
  hero,
  marquee,
  testimonials,
  instagram,
  product,
  header,
  announcement,
  account,
  newsletter,
  accordion,
  blogMenu,
  password,
  customBlush,
  recentCreations,
  videoEmbed,
};
export default picoapp(components, state);
